import _ from 'lodash'
import { enums, gql } from '@adc/sdk'
import fetch from '@adc/fetch'
import configment from '@adc/configment'

export const fetchSavedSearchDetailsV2 = (req, savedSearchId) =>
  fetch(
    `${configment.get(
      'RESI_MS_PROFILE'
    )}/resi/profile/v1/saved-searches/${savedSearchId}`,
    { req }
  )
    .then(res => res.body)
    .catch(err => {
      throw err.body
    })

export const saveSearch = input => {
  return fetch
    .forAuctionGraph({
      query: gql`
        mutation resiSearch_saveSearch($searchInput: SaveSearchInput!) {
          saveSearch(input: $searchInput) {
            saved_search_id
            saved_search_name
            parameters
            sms_notifications_enabled
          }
        }
      `,
      variables: {
        searchInput: {
          data_source_code: enums.SavedSearchSource.Adc,
          email_alert_type: 'DAILY',
          subscribed_to_notifications: true,
          param_version: 1,
          parameters: input.parameters,
          saved_search_name: input.saved_search_name,
        },
      },
    })
    .then(res => {
      const errors = _.get(res, 'body.errors[0]')
      if (errors) throw errors
      return res
    })
    .then(res => _.get(res, 'body.data.saveSearch', {}))
}

// eslint-disable-next-line camelcase
export const deleteSearch = ({ saved_search_id }) => {
  return fetch
    .forAuctionGraph({
      query: gql`
        mutation resiSearch_deleteSearch(
          $deleteSearchInput: DeleteSearchInput!
        ) {
          deleteSearch(input: $deleteSearchInput)
        }
      `,
      variables: {
        deleteSearchInput: {
          // eslint-disable-next-line camelcase
          saved_search_id,
        },
      },
    })
    .then(res => {
      const errors = _.get(res, 'body.errors[0]')
      if (errors) throw errors
      return res
    })
    .then(res => _.get(res, 'body.data.deleteSearch', {})) // TODO: logger.error if delete fails, should return deleteSearch: true it completely successful
}

export const updateSearch = input => {
  return fetch
    .forAuctionGraph({
      query: gql`
        mutation resiSearch_updateSearch(
          $updateSearchInput: UpdateSearchInput!
        ) {
          updateSavedSearch(input: $updateSearchInput) {
            saved_search_id
            saved_search_name
          }
        }
      `,
      variables: {
        updateSearchInput: {
          data_source_code: enums.SavedSearchSource.Adc,
          email_alert_type: 'DAILY',
          subscribed_to_notifications: true,
          param_version: 1,
          parameters: input.parameters || {},
          saved_search_name: input.saved_search_name,
          saved_search_id: input.saved_search_id,
        },
      },
    })
    .then(res => {
      const errors = _.get(res, 'body.errors[0]')
      if (errors) throw errors
      return res
    })
    .then(res => _.get(res, 'body.data.saveSearch', {}))
}

export const updateSearchRedesign = input => {
  return fetch
    .forAuctionGraph({
      query: gql`
        mutation resiSearch_updateSearch(
          $updateSearchInput: UpdateSearchInput!
        ) {
          updateSavedSearch(input: $updateSearchInput) {
            saved_search_id
            saved_search_name
            parameters
            sms_notifications_enabled
          }
        }
      `,
      variables: {
        updateSearchInput: {
          data_source_code: enums.SavedSearchSource.Adc,
          email_alert_type: 'DAILY',
          subscribed_to_notifications: true,
          param_version: 1,
          parameters: input.parameters || {},
          saved_search_name: input.saved_search_name,
          saved_search_id: input.saved_search_id,
          sms_notifications_enabled: input.sms_notifications_enabled,
        },
      },
    })
    .then(res => {
      const errors = _.get(res, 'body.errors[0]')
      if (errors) throw errors
      return res
    })
    .then(res => _.get(res, 'body.data.updateSavedSearch', {}))
}
